import React, { useState } from 'react';
import Menu from '../Menu.component';
import MenuIcon from '../../../01-atoms/images/icons/MenuIcon.component';
import { menuItemPropType } from '../MenuItem.component';
import bem from '../../../_utils/bem';

var MainMenu = function MainMenu(_ref) {
  var items = _ref.items;

  var _useState = useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var toggleMenu = function toggleMenu() {
    return setOpen(!isOpen);
  };

  var toggleModifiers = isOpen ? ['open'] : [];
  return /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("a", {
    id: "toggle-expand",
    className: bem('toggle-expand', '', toggleModifiers),
    onClick: toggleMenu
  }, /*#__PURE__*/React.createElement("span", {
    className: bem('toggle-expand', 'open')
  }, /*#__PURE__*/React.createElement(MenuIcon, {
    block: "toggle-expand",
    element: "icon"
  }), /*#__PURE__*/React.createElement("span", {
    className: bem('toggle-expand', 'text')
  }, "Menu")), /*#__PURE__*/React.createElement("span", {
    className: bem('toggle-expand', 'close')
  }, /*#__PURE__*/React.createElement("span", {
    className: bem('toggle-expand', 'text')
  }, "Close"))), /*#__PURE__*/React.createElement("div", {
    id: "main-nav",
    className: bem('main-nav', '', toggleModifiers)
  }, /*#__PURE__*/React.createElement(Menu, {
    block: "main-menu",
    items: items
  })));
};

export default MainMenu;